import { useEffect, useState } from "react";
import useBodyScrollLock from "hooks/useBodyScrollLock";
import { ROLE_LABELS } from "common/activeTypeGate";

export default function RoleChangeModal({ isShow, title, description, roles = [], onSelect, onAdd, onBack, addLabel }) {
  const [selecting, setSelecting] = useState(false);
  useBodyScrollLock(isShow);
  useEffect(() => { if (!isShow) setSelecting(false); }, [isShow]);
  if (!isShow) return null;

  return (
    <div className="modal-dimmed role-change-dimmed is-show">
      <div className="modal role-change-modal">
        <div className="role-change-symbol" aria-hidden="true">
          <svg viewBox="0 0 64 64" role="presentation">
            <circle cx="21" cy="27" r="7" /><path d="M10 48v-6c0-6 5-10 11-10s11 4 11 10v6" />
            <circle cx="44" cy="25" r="7" /><path d="M34 46v-5c0-6 4-10 10-10s10 4 10 10v5" />
            <path d="M24 14c7-7 17-7 23-1" /><path d="M44 9l4 4-4 4" />
            <path d="M40 53c-7 5-16 4-22-1" /><path d="M20 56l-4-4 4-4" />
          </svg>
        </div>
        {selecting ? <>
          <div className="tit-box"><p>전환할 회원유형을 선택해 주세요</p></div>
          <div className="role-change-list">
            {roles.map((role) => <button key={role} type="button" onClick={() => onSelect?.(role)}>
              {ROLE_LABELS[role] || role} 회원
            </button>)}
          </div>
          <div className="btn-group role-change-actions">
            <button type="button" className="role-change-back" onClick={() => setSelecting(false)}>이전</button>
          </div>
        </> : <>
          <div className="tit-box"><p>{title}</p></div>
          <div className="con-box"><p className="t-body">{description}</p></div>
          <div className="btn-group role-change-actions">
            <button type="button" className="btn-md filled primary" onClick={() => roles.length ? setSelecting(true) : onAdd?.()}>
              {roles.length ? "회원유형 전환하기" : (addLabel || "전문회원 유형 추가하기")}
            </button>
            <button type="button" className="role-change-back" onClick={onBack}>돌아가기</button>
          </div>
        </>}
      </div>
    </div>
  );
}
